import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject
} from "@angular/core";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderDetail, IAtgardBarighetChanged } from "../planera-detail/planera-detail-models";
import { ArbetsorderMediatorService } from "../services/arbetsorder-mediator.service";

@Component({
    selector: "rask-arbetsorder-spara",
    templateUrl: "./arbetsorder-spara.component.html",
    styleUrls: ["./arbetsorder-spara.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SaveButtonComponent]
})
export class ArbetsorderSparaComponent implements OnInit, OnDestroy {
    arbetsorder: IArbetsorderDetail;
    errors: string[];
    isDirty: boolean;
    isValid: boolean;
    @Input() updatedAtgardBarighet: IAtgardBarighetChanged[];

    private readonly arbetsorderMediatorService = inject(ArbetsorderMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    getErrors() {
        this.errors = this.arbetsorderMediatorService.getErrors();
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.arbetsorderMediatorService.arbetsorder
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(changeEvent => {
                this.arbetsorder = changeEvent?.arbetsorderWrapper?.arbetsorder;
            });

        this.arbetsorderMediatorService.dirty
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(dirty => {
                this.isDirty = dirty;
            });

        this.arbetsorderMediatorService.valid
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(valid => {
                this.isValid = valid;
                this.getErrors();
            });
    }

    save() {
        this.arbetsorderMediatorService.save(this.updatedAtgardBarighet).subscribe();
    }

    isDisabled(): boolean {
        return !this.isDirty || (ObjectUtils.hasValue(this.isValid) && !this.isValid);
    }

}
